import { Dispatch } from "redux";
import { actions as dataStoreAction } from "utils/DataStore/DataStore.reducer";

const initialRowsPerPage = 10;
const initialUsersPerPage = 20;
export const initialQuery = {
    limit: initialRowsPerPage as typeof initialRowsPerPage,
    order: "+name",
};

export const initialUserQuery = {
    limit: initialUsersPerPage as typeof initialUsersPerPage,
    order: "+name",
    offset: 0,
};

const defaultVariables = {
    query: initialUserQuery,
    filter: {},
};

export const fetchUserList = (dispatch: Dispatch, variables = defaultVariables) => {
    const filterStr = Object.values(variables.filter).length
        ? JSON.stringify(variables.filter)
        : null;
    return new Promise((resolve, reject) => {
        dispatch({
            type: dataStoreAction.START_FETCH_DATA,
            promise: { resolve, reject },
            key: "allUsers",
            params: {
                query: `query($filter:String, $order: String, $limit: Int, $offset: Int){
                        user_list(filter: $filter, limit: $limit, order: $order, offset: $offset){
                            user_count
                            user_list {
                                id
                                id_identity {
                                    id
                                }
                                name
                                email
                                is_twofa_enabled
                                is_enabled
                                is_activated
                                last_login
                                is_locked_out
                                last_activity
                                icon
                                identity_role_plain_list_identity_id(limit:20, order:"+id"){
                                    id
                                    role_id_role {
                                        id
                                        name
                                    }
                                    propagate
                                }
                            }
                    
                        }
                    }`,
                variables: {
                    ...variables.query,
                    filter: filterStr,
                },
            },
        });
    });
};
